// src/Pages/Purchase/Bills.jsx
import React, { useState } from "react";
import { useBills } from "../../context/BillsContext";
import { Link, useNavigate } from "react-router-dom";
import "./Bills.css";

const Bills = () => {
  const { bills } = useBills();
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const filteredBills = bills.filter(
    (bill) =>
      bill.billNo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      bill.vendorName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      bill.referenceNo?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getStatusClass = (status) => {
    switch ((status || "").toUpperCase()) {
      case "PAID":
        return "status-paid";
      case "OPEN":
        return "status-open";
      case "OVERDUE":
        return "status-overdue";
      case "DRAFT":
      default:
        return "status-draft";
    }
  };

  const handleRowClick = (billId) => {
    navigate(`/purchase/bills/view/${billId}`);
  };

  const formatCurrency = (amount) => {
    return (
      "₹" +
      Number(amount || 0).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  };

  const formatDate = (date) => {
    try {
      return new Date(date).toLocaleDateString("en-IN");
    } catch {
      return "—";
    }
  };

  return (
    <div className="bills-wrapper">
      <div className="bills-container">
        {/* Header */}
        <div className="bills-header">
          <h1>All Bills</h1>
          <div className="header-actions">
            <input
              type="text"
              placeholder="Search by Bill#, Vendor or Reference..."
              className="search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Link to="/purchase/bills/new">
              <button className="new-bill-btn">+ New Bill</button>
            </Link>
          </div>
        </div>

        {/* Empty State */}
        {filteredBills.length === 0 && (
          <div className="state-card empty">
            <h3>
              {searchTerm
                ? `No bills found for "${searchTerm}"`
                : "No Bills Recorded Yet"}
            </h3>
            <p>Start recording vendor bills to track your expenses.</p>
            <Link to="/purchase/bills/new">
              <button className="new-bill-btn">+ Record First Bill</button>
            </Link>
          </div>
        )}

        {/* Bills List */}
        {filteredBills.length > 0 && (
          <div className="bills-list">
            {/* Desktop Header */}
            <div className="table-header5">
              <span></span>
              <span>DATE</span>
              <span>BILL#</span>
              <span>REFERENCE#</span>
              <span>VENDOR</span>
              <span>STATUS</span>
              <span>DUE DATE</span>
              <span>AMOUNT</span>
              <span>BALANCE DUE</span>
            </div>

            {/* Rows */}
            {filteredBills.map((bill) => (
              <div
                key={bill._id}
                className="bill-row"
                onClick={() => handleRowClick(bill._id)}
              >
                <input type="checkbox" onClick={(e) => e.stopPropagation()} />

                <span data-label="Date">{formatDate(bill.date)}</span>

                <span data-label="Bill#" className="bill-no">
                  {bill.billNo}
                </span>

                <span data-label="Reference#">{bill.referenceNo || "—"}</span>

                <span data-label="Vendor" className="vendor-name">
                  {bill.vendorName || "Unknown Vendor"}
                </span>

                <span
                  data-label="Status"
                  className={`status-badge ${getStatusClass(bill.status)}`}
                >
                  {bill.status || "Draft"}
                </span>

                <span data-label="Due Date">
                  {bill.dueDate ? formatDate(bill.dueDate) : "—"}
                </span>

                <span data-label="Amount" className="amount">
                  {formatCurrency(bill.amount || bill.total)}
                </span>

                <span data-label="Balance Due" className="balance-due">
                  {formatCurrency(bill.balanceDue || bill.total || 0)}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Bills;
